import {BaseExportsController} from './base-controller';
import moment from "moment";

class RsvpExportsController extends BaseExportsController {

    constructor($scope, $rootScope, $injector) {
        super($scope, $rootScope, $injector);

        this.locale = this.injector.get('locale');
        this.shiftsStore = this.injector.get('GuestlistShifts').reset({
            persists: false,
            listview: 'RsvpExportsSelectShiftListView'
        });
        this.areasStore = this.injector.get('SeatplanAreas').reset({
            persists: false,
            listview: 'RsvpExportsSelectAreaListView'
        });
        this.objectsStore = this.injector.get('BoObjects').reset({
            persists: false,
            listview: 'RsvpExportsSelectObjectsListView'
        });

        this.deposits = {
            states: [],
            booked_options_group_types: [
                {
                    value: 'day',
                    label: 'Day'
                },
                {
                    value: 'day_shift',
                    label: 'Day and shift'
                },
                {
                    value: 'day_area_shift',
                    label: 'Day, area and shift'
                },
                {
                    value: 'day_time',
                    label: 'Day and start time'
                },
                {
                    value: 'day_area_time',
                    label: 'Day, area and start time'
                },
                {
                    value: 'shift',
                    label: 'Shift'
                },
                {
                    value: 'area',
                    label: 'Area'
                }
            ]
        };

        this.prepareStates();
    }

    prepareStates() {
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            _.each(value, (v, k) => {
                this.deposits.states.push({
                    value: k,
                    label: v
                });
            });
        });
    }

    getSideNavActions() {
        const out = [
            {
                label: 'Rsvps without bids',
                view: 'rsvps_without_bids',
                description: 'Exports all rsvps without a generated Bid',
                path: 'exports/rsvps/without-bid',
                fileName: 'RsvpsWithoutBids.xlsx',
                fields: [
                    'start_date',
                    'end_date'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates
                    }
                }
            },
            {
                label: 'Rsvps with invoice address',
                view: 'rsvps_with_invoice_addresses',
                description: 'Exports all rsvps with the correct invoice address',
                path: 'exports/rsvps/invoice-addresses',
                fileName: 'RsvpsWithInvoiceAddresses.xlsx',
                fields: [
                    'start_date',
                    'end_date',
                    'states'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.rsvps_invoice_address_export_states)
                    };
                }
            },
            {
                label: 'Rsvps A-Z List',
                view: 'rsvps_a_to_z_list',
                description: 'Creates A-Z list for all selected rsvps grouped by table display names',
                path: 'exports/rsvps/az-list',
                fileName: 'A-Z.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'states',
                    'shifts',
                    'areas',
                    'only_paid'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.az_list_default_states),
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.az_list_default_areas),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.az_list_default_shifts),
                        only_paid: _.cloneDeep(this.userStore.state.company.settings.exports.only_paid),
                    };
                }
            },
            {
                label: 'Rsvps A-Z List special',
                view: 'rsvps_a_to_z_list_special',
                description: 'Special A-Z List',
                path: 'exports/rsvps/az-list-special',
                fileName: 'A-Z Special.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'states',
                    'shifts',
                    'areas',
                    'only_paid'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.az_list_default_states),
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.az_list_default_areas),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.az_list_default_shifts),
                        only_paid: _.cloneDeep(this.userStore.state.company.settings.exports.only_paid),
                    };
                }
            },
            {
                label: 'Area Usage Report',
                view: 'area_usage_report',
                description: 'Creates report for area usage',
                path: 'exports/rsvps/area-usage',
                fileName: 'area_usage.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'shifts',
                    'areas'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.area_usage_default_shifts),
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.area_usage_default_areas)
                    };
                }
            }
        ];

        if(_.cloneDeep(this.userStore.state.company.settings.exports.area_usage_special_enabled)) {
            out.push(
                {
                    label: 'Area Usage Special Report',
                    view: 'area_usage_special_report',
                    description: 'Creates special report for area usage',
                    path: 'exports/rsvps/area-usage-special',
                    fileName: 'area_usage_special.pdf',
                    fields: [
                        'start_date',
                        'end_date',
                        'shifts',
                        'areas'
                    ],
                    activator: () => {
                        this.currentData = {
                            ...this.defaultGuestlistDates,
                            shifts: _.cloneDeep(this.userStore.state.company.settings.exports.area_usage_default_shifts),
                            areas: _.cloneDeep(this.userStore.state.company.settings.exports.area_usage_default_areas)
                        };
                    }
                })
        }

        return out.concat([
            {
                label: 'Info documents',
                view: 'rsvps_info_documents',
                description: 'Creates info documents for all rsvps selected by the given filters',
                path: 'exports/rsvps/info-docs',
                fileName: 'Info-Docs.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'states',
                    'shifts',
                    'areas'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.info_docs_default_states),
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.info_docs_default_areas),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.info_docs_default_shifts),
                    };
                }
            },
            {
                label: 'Info documents list',
                view: 'rsvps_info_documents_list',
                description: 'Creates the list of info documents for all rsvps selected by the given filters',
                path: 'exports/rsvps/info-docs-list',
                fileName: 'Info-Docs-List.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'states',
                    'shifts',
                    'areas'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.info_docs_default_states),
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.info_docs_default_areas),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.info_docs_default_shifts),
                    };
                }
            },
            {
                label: 'Booked options',
                view: 'rsvps_booked_options',
                description: 'Creates the list of all booked Options grouped by objects and shifts',
                path: 'exports/bookable-objects/booked-options',
                fileName: 'booked-options.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'states',
                    'shifts',
                    'areas',
                    'objects',
                    'booked_options_group_by',
                    'only_paid'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.booked_options_default_areas),
                        objects: _.cloneDeep(this.userStore.state.company.settings.exports.booked_options_default_objects),
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.booked_options_default_states),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.booked_options_default_shifts),
                        group_type: _.cloneDeep(this.userStore.state.company.settings.exports.booked_options_default_group_type),
                        only_paid: _.cloneDeep(this.userStore.state.company.settings.exports.booked_options_default_only_paid)
                    };
                }
            },
            {
                label: 'Kitchen export',
                view: 'rsvps_kitchen_export',
                description: 'Creates the kitchen export',
                path: 'exports/bookable-objects/kitchen-export',
                fileName: 'kitchen-export.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'states',
                    'shifts',
                    'areas',
                    'objects',
                    'only_paid'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.kitchen_export_default_areas),
                        objects: _.cloneDeep(this.userStore.state.company.settings.exports.kitchen_export_default_objects),
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.kitchen_export_default_states),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.kitchen_export_default_shifts),
                        only_paid: _.cloneDeep(this.userStore.state.company.settings.exports.kitchen_export_default_only_paid)
                    };
                }
            },
            {
                label: 'Table cards',
                view: 'rsvps_table_cards',
                description: 'Creates table cards for all rsvps selected by the given filters',
                path: 'exports/rsvps/table-cards',
                fileName: 'Table-Cards.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'areas',
                    'states',
                    'shifts'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.table_card_default_areas),
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.table_card_default_states),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.table_card_default_shifts),
                    };
                }
            },
            {
                label: 'PDF Seatplan',
                view: 'rsvps_pdf_seatplan',
                description: 'Creates pdf seatplan for all rsvps selected by the given filters',
                path: 'exports/rsvps/pdf-seatplan',
                fileName: 'Seatplan.pdf',
                fields: [
                    'start_date',
                    'end_date',
                    'states',
                    'shifts',
                    'areas'
                ],
                activator: () => {
                    this.currentData = {
                        ...this.defaultGuestlistDates,
                        states: _.cloneDeep(this.userStore.state.company.settings.exports.pdf_seatplan_default_states),
                        shifts: _.cloneDeep(this.userStore.state.company.settings.exports.pdf_seatplan_default_shifts),
                        areas: _.cloneDeep(this.userStore.state.company.settings.exports.pdf_seatplan_default_areas),
                    };
                }
            }
        ]);
    }
}

angular.module('festzelt-os.exports')
    .controller('RsvpExportsController', RsvpExportsController);



// WEBPACK FOOTER //
// ./src/app/pages/exports/controllers/rsvps-controller.js